import axios from "axios/index";
import api from "../../config/_api";
import {SYSTEM_ALARM_SEUIL_UPDATED} from "../actions/system_alarm_seuil";

const state = {
    system_alarm_seuil: []
};

const actions = {
    getSysAlarmSeuil: ({commit, rootGetters}) => {
        //todo rajouter system_id
        axios({url: api.url + 'sysAlarmSeuil?structure_id=' + rootGetters.structure_id, method: 'GET' })
            .then(resp => {
                commit('SYSTEM_ALARM_SEUIL_UPDATED', resp.data);
            })
          .catch(err => {
               // console.log("error");
            });
    },
    //recupere un seuil_alarm sur un system
    getSysSeuil: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
          axios({url: api.url + 'sysAlarmSeuil?system_id=' + payload.system_id, method: 'GET'})
            .then(resp => {
              commit('SYSTEM_ALARM_SEUIL_UPDATED', resp.data);
              resolve(resp.data); // résoudre la promesse avec la réponse
            })
            .catch(err => {
              reject(err); // rejeter la promesse avec l'erreur
            });
        });
    },
    update({commit}, payload) {
        const params = new URLSearchParams();
        params.append('unit_type', payload.unit_type);
        params.append('seuil_type', payload.seuil_type);
        params.append('dest_id', payload.dest_id);
        params.append('seuil', payload.seuil);
        params.append('alarm_name', payload.alarm_name);
        
        // TODO : Replace structure id by rootGetters.structure_id
        return new Promise((resolve, reject) => {
            axios.put(api.url + 'sysAlarmSeuil/' + payload.id, params)
            .then((response) => {
                commit('removeSysAlarm', payload.id);
                commit('addSysAlarm', response.data);
                resolve(response.data); // résoudre la promesse avec la réponse
            })
            .catch((error) => {
                reject(error); 
            })
        });
        
    },
    create({commit, rootGetters}, payload) {
        
        const params = new URLSearchParams();
        params.append('unit_type', payload.unit_type);
        params.append('seuil_type', payload.seuil_type);
        params.append('dest_id', payload.dest_id);
        params.append('seuil', payload.seuil);
        params.append('alarm_name', payload.alarm_name);
        params.append('system_id', payload.system_id);
        params.append('structure_id', rootGetters.structure_id);

        // TODO : Replace structure id by rootGetters.structure_id
        return new Promise((resolve, reject) => {
            axios.post(api.url + 'sysAlarmSeuil', params)
            .then((response) => {
                commit('addSysAlarm', response.data);
                commit('removeSysAlarm', -1);
                resolve(response.data); // résoudre la promesse avec la réponse
            })
            .catch((error) => {
                reject(error); 
            })
        });
    },
};
const mutations = {
    [SYSTEM_ALARM_SEUIL_UPDATED]: (state, system_alarm_seuil) => {
        state.system_alarm_seuil = system_alarm_seuil;
    },
    ['addSysAlarm']: (state, alarm) => {
        state.system_alarm_seuil.push(alarm);
    },
    ['removeSysAlarm']: (state, id) => {
        var index = state.system_alarm_seuil.findIndex(event => event.id === id);
        state.system_alarm_seuil.splice(index, 1);
    },
};


const getters = {
    system_alarm_seuil : state => state.system_alarm_seuil,
};
const defaultPopperProps = {
    arrowPosition: 'start',
    arrowOffsetScaling: 1,
    popperOptions: {
      placement: 'bottom-start',
      positionFixed: true,
      // more options in https://popper.js.org
    },
  }
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    defaultPopperProps,
    getters
};
